import React, { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';
import { TopBarProvider } from '../contexts/TopBarContext';
import TopBar from './TopBar';
import Sidebar from './Sidebar';
import type { SidebarMode } from './Sidebar';
import './AppLayout.css';

const SIDEBAR_CYCLE: SidebarMode[] = ['open', 'collapsed', 'hidden'];

const AppLayout: React.FC = () => {
  const { isDarkMode } = useTheme();
  const [sidebarMode, setSidebarMode] = useState<SidebarMode>('collapsed');

  const cycleSidebar = useCallback(() => {
    setSidebarMode(prev => {
      const idx = SIDEBAR_CYCLE.indexOf(prev);
      return SIDEBAR_CYCLE[(idx + 1) % SIDEBAR_CYCLE.length];
    });
  }, []);

  return (
    <TopBarProvider>
      <div className="app-layout" data-theme={isDarkMode ? 'dark' : 'light'}>
        <Sidebar mode={sidebarMode} onToggle={cycleSidebar} />

        <div className="right-side">
          <TopBar
            onSidebarToggle={cycleSidebar}
            sidebarMode={sidebarMode}
          />

          <main className="main-content">
            <Outlet />
          </main>
        </div>
      </div>
    </TopBarProvider>
  );
};

export default AppLayout;